

































/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig } from "../../../Models/Buttons";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";

import axios from "axios";
import { IIssueService } from "../../../BusinessServices/issue";
import { IssueModel, BlobReplaceDTO } from "../../../Generated/ParticaAPI";
import { IIssueConversionService } from "../../../BusinessServices/issueconversion";
import PdfUploader from "../../../Ui-Components/Uploader/PdfUploader.vue";


@Component(
	{
		name: "IssuePdfReplace",
		components: {
			ButtonList,
			ParticaCard,
			ParticaView,

			PdfUploader
		}
	})
export default class IssuePdfReplace extends ParticaIssueBase {
	@Prop() private id: number;
	private files: File[] = [];
	private uploadProgress: { [key: string]: { state: string; percentage: number } } = {};
	private uploading = false;
	private successfullUploaded = false;
	private multiple = false;
	private issueService: IIssueService;
	private issue: IssueModel = new IssueModel();
	private conversionService: IIssueConversionService;
	private maxFiles: number = 1;

	private buttons: ButtonConfig[] = [
		// { label: "Add new issue", action: eParticaAction.ISSUE_ADD, type: ButtonType.Normal } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {

				case eParticaAction.PDF_UPLOAD: {
					this.files = event.item as File[];
					await this.uploadFiles();
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	@Watch("route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Source PDF Replace";
		await this.init();
		await this.getIssueNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			this.issueService = this.particaServices.getIssueService();
			this.conversionService = this.particaServices.getIssueConversionService();
			this.issue = await this.issueService.getIssue(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}

	private async uploadFiles() {
		// get environment conversion path, sas
		const blobsas: BlobReplaceDTO = await this.conversionService.getSourceBlob(this.id);
		this.uploading = true;
		this.uploadProgress = {};
		const promises: Promise<any>[] = [];
		this.files.forEach(file => {
			this.uploadProgress[file.name] ? this.uploadProgress[file.name].state : "idle";
			this.uploadProgress[file.name] ? this.uploadProgress[file.name].percentage : 0;
			promises.push(this.sendRequest(file, blobsas.sas as string, blobsas.blob as string));
		});
		try {
			await Promise.all(promises);
			// this.uploading = false;
			// this.successfullUploaded = true;
			await this.conversionService.restartIssue(this.id);
			this.ShowSnackbar("Upload complete. The issue will now be processed.");
		} catch (error) {
			this.ShowErrorDialog(error, "Error uploading PDF. Try again.");
			this.uploading = false;
			// Just do this for now...
			this.successfullUploaded = true;
		}
	}
	private sendRequest(file: File, sas: string, path: string) {
		return new Promise((resolve, reject) => {
			const config: any = {
				baseUrl: path,
				sasToken: sas,
				file,
				progress: (data: any) => {
					this.uploadProgress[file.name] = { state: "pending", percentage: data };
					this.uploadProgress = { ...this.uploadProgress };
				},
				complete: (data: any) => {
					resolve(data);
				},
				error: (data: any) => {
					reject(data);
				}
			};
			// @ts-ignore
			return this.$azureUpload(config, axios.create({
				transformRequest: [
					(data, headers) => {
						delete headers.common.Authorization;
						return data;
					}
				]
			}));
		});
	}
}
